const labels: Record<string, string> = {
  pending_finality: 'Request pending finality', queued: 'Receipt escrow request finalized',
  awaiting_native_registration: 'Authorize the BNB payout minimum',
  source_preparation: 'Source eligibility and backing reservation pending', source_release: 'Source release pending', source_sale: 'Source sale pending', return_bridge: 'Return bridge pending',
  source_release_pending: 'Source release pending', source_sale_pending: 'Source sale pending',
  source_sell_pending: 'Source sale pending', sale_pending: 'Source sale pending',
  bridge_pending: 'Return bridge pending', return_bridge_pending: 'Return bridge pending',
  payout_pending: 'Destination payout pending', completed: 'Settlement completed',
  retry_required: 'Recovery needed', failed: 'Request failed', blocked: 'Route unavailable',
  cancellation_pending: 'Cancellation acknowledgement pending', cancelled: 'Cancellation acknowledged',
};
export function settlementLabel(state: string) { return labels[state] ?? state.replaceAll('_', ' '); }
export function settlementTone(state: string) {
  if (['failed', 'retry_required'].includes(state)) return 'error';
  if (['completed', 'cancelled'].includes(state)) return 'completed';
  if (state === 'blocked') return 'unavailable';
  return 'active';
}
export function reviewStatus(reviewedAt: number | null, now = Date.now(), reviewDueAt?: number | null) {
  if (!reviewedAt || reviewedAt <= 0 || !Number.isFinite(reviewedAt) || reviewedAt > now) {
    if (reviewedAt === null && reviewDueAt && Number.isFinite(reviewDueAt)) return now > reviewDueAt ? 'Initial review overdue against the 12-hour target' : 'Awaiting initial review';
    return 'No verified review timestamp';
  }
  return 'Review recorded; follow-up cadence is not scheduled';
}
